import type { NewsArticle } from './newsArticle.js'
import { newsRelativePath, parseNewsArticle, resolveNewsPath, sortNewsArticles } from './newsArticle.js'

const rawArticles = import.meta.glob<string>('../../News/**/*.md', { query: '?raw', import: 'default', eager: true })
const imageUrls = import.meta.glob<string>('../../News/**/*.{png,jpg,jpeg,gif,webp,svg}', {
  query: '?url',
  import: 'default',
  eager: true
})

const images = new Map(Object.entries(imageUrls).map(([key, url]) => [newsRelativePath(key), url]))

export const newsArticles: NewsArticle[] = sortNewsArticles(
  Object.entries(rawArticles).flatMap(([key, raw]) => {
    const article = parseNewsArticle(newsRelativePath(key), raw)
    if (!article && import.meta.env.DEV) {
      console.warn(`News article ${key} lacks slug, title or date in its front matter and is not shown`)
    }
    return article ? [article] : []
  })
)

export const latestNewsArticle: NewsArticle | undefined = newsArticles[0]

export const findNewsArticle = (slug: string | undefined): NewsArticle | undefined => newsArticles.find((a) => a.slug === slug)

/** Bundled URL of an image referenced from an article, or undefined when the file does not exist (yet). */
export const newsImageUrl = (article: Pick<NewsArticle, 'dir'>, src: string | undefined): string | undefined =>
  src ? images.get(resolveNewsPath(article.dir, src)) : undefined
